export class SpeciesNameSearchCriteria {
  public matchAgainstReport = true;
  public reportId: number;
  public nameCriteria: string;

  public pageNumber = 1;
  public pageSize = 12;
}
